export default "__VITE_ASSET__BY1k5E8y__"